<template>
  <div tabindex="0" class="testimonial-card" :style="{ backgroundColor: colors.testimonialsCardBg }">
    <div class="testimonial-header">
      <img :src="image" :alt="name" class="testimonial-img" />
      <div class="testimonial-info">
        <h3 class="testimonial-name" :style="{ color: colors.primaryText }">{{
          name
        }}</h3>
        <span class="testimonial-profession" :style="{ color: colors.primaryText }">{{ profession }}</span>
      </div>
    </div>
    <p class="testimonial-description" :style="{ color: colors.primaryText }">
      {{ description }}
    </p>
  </div>
</template>

<script setup>
import { useTheme } from "~/composables/useTheme";

const { colors } = useTheme();
const props = defineProps({
  image: { type: String, required: true },
  name: { type: String, required: true },
  profession: { type: String, required: true },
  description: { type: String, required: true },
});
</script>

<style scoped>
img {
  filter: grayscale(100%);
}

.testimonial-card {
  background-color: #fff;
  border-radius: 16px;
  padding: 26px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  width: 90%;
  min-height: 190px;
  /* text-align: center; */
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.testimonial-header {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-bottom: 12px;
}

.testimonial-img {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  object-fit: cover;
  margin-bottom: 8px;
}

.testimonial-name {
  font-weight: 600;
  font-size: 16px;
  line-height:0.5;
  display: block;
}

.testimonial-profession {
  font-size: 14px;
  color: #777;
  display: block;
}

.testimonial-description {
  font-size: 14px;
  color: #333;
}
</style>
